import React, { useState, useEffect } from 'react';
import News from './News';
import { FiDownload, FiX, FiShare } from 'react-icons/fi';
import { AiFillApple } from 'react-icons/ai';
import { FaGooglePlay, FaAndroid } from 'react-icons/fa';

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosModal, setShowIosModal] = useState(false);
  const [isAppInstalled, setIsAppInstalled] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    // Megnézzük, hogy már app módban fut-e
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
      setIsAppInstalled(true);
    }

    // Android telepítési esemény figyelése
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /android/i.test(ua);

    if (isIOS) {
      setShowIosModal(true);
    } else if (isAndroid) {
      // Androidon a Play Store-ba irányítunk
      window.location.href = "https://play.google.com/store/apps/details?id=com.archerynexus.app";
    } else if (deferredPrompt) {
      // Asztali gépen vagy egyéb eszközön (ha támogatja a PWA-t)
      deferredPrompt.prompt();
    } else {
      alert("A telepítéshez használd a böngésződ menüjét!");
    }
  };

  const containerStyle = {
    padding: isMobile ? '1.5rem 1rem' : '3rem 1.5rem',
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '1.5rem' : '3rem',
    backgroundColor: '#fdfdfd'
  };

  const headerStyle = {
    textAlign: 'center',
    padding: isMobile ? '1rem 0' : '2rem 0',
    background: 'linear-gradient(to bottom, #fff, #fdfdfd)',
    borderRadius: '20px',
    marginBottom: '1rem'
  };

  const titleStyle = {
    color: '#b30000',
    fontSize: isMobile ? '1.8rem' : '2.8rem',
    fontWeight: '800',
    marginBottom: '0.5rem',
    letterSpacing: '-0.5px'
  };

  const subTitleStyle = {
    fontSize: isMobile ? '1rem' : '1.25rem',
    color: '#555',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: '1.5'
  };

  const sectionTitleStyle = {
    fontSize: isMobile ? '1.4rem' : '1.8rem',
    color: '#333',
    borderBottom: '3px solid #b30000',
    paddingBottom: '0.5rem',
    marginBottom: '1.5rem',
    display: 'inline-block'
  };

  const footerStyle = {
    marginTop: 'auto',
    padding: '3rem 0',
    borderTop: '1px solid #eee',
    textAlign: 'center',
    color: '#888',
    fontStyle: 'italic',
    fontSize: '0.95rem'
  };

  const installButtonStyle = {
    backgroundColor: '#b30000',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    padding: '12px 24px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    margin: '1.5rem auto 0 auto',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    width: 'fit-content'
  };

  const googlePlayBadgeStyle = {
    backgroundColor: '#000',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    width: 'fit-content',
    margin: '1.5rem auto 10px auto',
    textDecoration: 'none',
    minWidth: '180px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
  };

  const iosButtonStyle = {
    ...googlePlayBadgeStyle,
    backgroundColor: '#333',
    margin: '0 auto',
    padding: '10px 16px',
  };

  // --- ÚJ KOMPAKT STÍLUSOK ---
  const compactRowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 15px',
    backgroundColor: '#fff',
    borderRadius: '16px',
    marginBottom: '10px',
    border: '1px solid #eee',
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
  };

  const benefitTextStyle = {
    fontSize: '0.8rem',
    color: '#666',
    textAlign: 'left',
    flex: 1,
    paddingRight: '10px',
    lineHeight: '1.3'
  };

  const miniBadgeStyle = {
    backgroundColor: '#000',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    cursor: 'pointer',
    minWidth: '130px',
    height: '40px'
  };

  const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center',
    alignItems: 'center', zIndex: 3000, padding: '20px'
  };

  const modalContentStyle = {
    backgroundColor: 'white', padding: '30px', borderRadius: '20px',
    maxWidth: '320px', textAlign: 'center', position: 'relative'
  };

  return (
    <main style={containerStyle} className="force-light-theme">
      {/* FEJLÉC ÉS ÜDVÖZLÉS */}
      <header style={headerStyle}>
        <h1 style={titleStyle}>Üdvözöl az ArcheryNexus!</h1>
        <p style={subTitleStyle}>
          Minden, ami magyar íjászat: friss hírek, versenyek és statisztikák. Vezesd fejlődésedet a <strong>mobilalkalmazásban</strong>, és bonyolítsd le versenyeidet teljesen digitálisan az asztali <strong>Versenyiroda</strong> segítségével!
        </p>

        {/* TELEPÍTÉS SZEKCIÓ - KOMPAKT MOBIL NÉZET */}
        {isMobile && !isAppInstalled && (
          <div style={{ marginTop: '1.5rem', width: '100%', maxWidth: '450px', margin: '1.5rem auto 0 auto' }}>
            {/* ANDROID SOR */}
            <div style={compactRowStyle}>
              <div style={benefitTextStyle}>
                <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '0.85rem', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <FaAndroid size={16} /> Android alkalmazás
                </div>
                Natív élmény minden extra funkcióval
              </div>
              <button style={miniBadgeStyle} onClick={handleInstallClick}>
                <FaGooglePlay size={18} />
                <span style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Google Play</span>
              </button>
            </div>

            {/* iOS SOR */}
            <div style={compactRowStyle}>
              <div style={benefitTextStyle}>
                <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '0.85rem', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <AiFillApple size={18} /> iOS / iPhone
                </div>
                100% offline működés a lővonalon is
              </div>
              <button style={{ ...miniBadgeStyle, backgroundColor: '#333' }} onClick={() => setShowIosModal(true)}>
                <AiFillApple size={20} />
                <span style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Telepítés</span>
              </button>
            </div>
          </div>
        )}
      </header>

      {/* iOS TELEPÍTÉSI ÚTMUTATÓ MODAL */}
      {showIosModal && (
        <div style={modalOverlayStyle} onClick={() => setShowIosModal(false)}>
          <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
            <button
              onClick={() => setShowIosModal(false)}
              style={{ position: 'absolute', right: '15px', top: '15px', border: 'none', background: 'none', cursor: 'pointer' }}
            >
              <FiX size={24} color="#666" />
            </button>
            <h3 style={{ color: '#b30000', marginBottom: '15px' }}>Telepítés iPhone-ra</h3>
            <p style={{ fontSize: '0.9rem', color: '#444', lineHeight: '1.6' }}>
              Az ArcheryNexus alkalmazásként való használatához kövesd ezeket a lépéseket:
            </p>
            <div style={{ textAlign: 'left', margin: '20px 0', fontSize: '0.9rem' }}>
              <p>1. Koppints a <strong>Megosztás</strong> gombra <FiShare style={{ verticalAlign: 'middle' }} /> alul.</p>
              <p>2. Görgess le és válaszd a <strong>Főképernyőhöz adás</strong> opciót.</p>
            </div>
            <button
              style={{ ...installButtonStyle, width: '100%', margin: '10px 0 0 0' }}
              onClick={() => setShowIosModal(false)}
            >
              Értem
            </button>
          </div>
        </div>
      )}

      {/* HÍREK SZEKCIÓ */}
      <section>
        <h2 style={sectionTitleStyle}>Hírek a Magyar Íjász Szövetségtől</h2>
        <News />
      </section>

      {/* FEJLESZTÉS ALATT ÜZENET */}
      <footer style={footerStyle}>
        <div style={{ marginBottom: '10px' }}>🏹 ArcheryNexus v1.0 (Web)</div>
        <p>
          Az oldal folyamatos fejlesztés alatt áll. Hamarosan új tartalmakkal érkezünk!
        </p>
      </footer>
    </main>
  );
};

export default HomePage;



